import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { 
  Card, 
  Button, 
  Switch, 
  Table,
  Typography,
  Input,
  Form,
  Row,
  Col,
  Divider
} from 'antd';
import { 
  ArrowRightOutlined,
  CheckOutlined,
  DragOutlined
} from '@ant-design/icons';
import { message } from 'antd';

const { Title, Text } = Typography;
const { TextArea } = Input;

const LeadForm = () => {
  const navigate = useNavigate();
  
  // لیست فیلدهای فرم
  const [fields, setFields] = useState([
    { id: 1, key: 'name', label: 'نام', enabled: true, required: true, order: 1 },
    { id: 2, key: 'email', label: 'ایمیل', enabled: false, required: false, order: 2 },
    { id: 3, key: 'company', label: 'نام شرکت', enabled: false, required: false, order: 3 },
    { id: 4, key: 'website', label: 'وب‌سایت', enabled: false, required: false, order: 4 },
    { id: 5, key: 'address', label: 'آدرس', enabled: false, required: false, order: 5 },
    { id: 6, key: 'mobile', label: 'موبایل', enabled: true, required: false, order: 6 },
    { id: 7, key: 'message', label: 'پیام', enabled: true, required: false, order: 7 },
    { id: 8, key: 'city', label: 'شهر', enabled: false, required: false, order: 8 },
    { id: 9, key: 'state', label: 'استان', enabled: false, required: false, order: 9 },
    { id: 10, key: 'country', label: 'کشور', enabled: false, required: false, order: 10 },
    { id: 11, key: 'postalCode', label: 'کد پستی', enabled: false, required: false, order: 11 },
    { id: 12, key: 'source', label: 'منبع', enabled: false, required: false, order: 12 },
    { id: 13, key: 'product', label: 'محصول', enabled: false, required: false, order: 13 },
  ]);

  const handleToggleField = (fieldId) => {
    setFields(prevFields => 
      prevFields.map(field => 
        field.id === fieldId 
          ? { ...field, enabled: !field.enabled }
          : field
      )
    );
  };

  // فیلدهای فعال برای نمایش در پیش‌نمایش
  const enabledFields = fields
    .filter(field => field.enabled)
    .sort((a, b) => a.order - b.order);

  const columns = [
    {
      title: '#',
      dataIndex: 'order',
      key: 'order',
      width: 50,
      render: (text) => <span style={{ fontFamily: 'CustomFont' }}>{text}</span>,
    },
    {
      title: 'فیلد',
      dataIndex: 'label',
      key: 'label',
      render: (text, record) => (
        <div className="flex items-center gap-2">
          <DragOutlined className="text-gray-400 cursor-move" />
          <span style={{ fontFamily: 'CustomFont' }}>{text}</span>
          {record.required && <span className="text-red-500">*</span>}
        </div>
      ),
    },
    {
      title: 'وضعیت',
      key: 'status',
      width: 100,
      align: 'center',
      render: (_, record) => {
        // فیلد Name همیشه فعال است و Switch ندارد
        if (record.key === 'name') {
          return <span style={{ fontFamily: 'CustomFont', color: '#8c8c8c' }}>-</span>;
        }
        return (
          <Switch
            checked={record.enabled}
            onChange={() => handleToggleField(record.id)}
            checkedChildren="فعال"
            unCheckedChildren="غیرفعال"
          />
        );
      },
    },
  ];

  return (
    <MainLayout>
      <div className="" style={{ fontFamily: 'CustomFont' }}>
        {/* Card اصلی */}
        <Card 
          className="shadow-xl border-0"
          bodyStyle={{ padding: 0 }}
        >
          {/* Header */}
          <div className="border-b border-gray-200 dark:border-gray-700 p-6 bg-white dark:bg-gray-800 rounded-t-lg">
            <div className="flex items-center justify-between">
              <Title 
                level={2}
                className="mb-0"
                style={{ fontFamily: 'CustomFont' }}
              >
                فرم سرنخ
              </Title>
              <Button
                icon={<ArrowRightOutlined />}
                onClick={() => navigate('/leads')}
                size="middle"
                style={{ fontFamily: 'CustomFont' }}
              >
                بازگشت
              </Button>
            </div>
          </div>

          {/* Content */}
          <div className="p-6 bg-gray-50 dark:bg-gray-900/50">
            <Row gutter={[24, 24]}>
              {/* ستون راست: تنظیمات فیلدها */}
              <Col xs={24} lg={12}>
                <Card 
                  className="h-full"
                  title={
                    <span style={{ fontFamily: 'CustomFont' }}>تنظیمات فیلدها</span>
                  }
                >
                  <Table
                    columns={columns}
                    dataSource={fields}
                    rowKey="id"
                    pagination={false}
                    size="middle"
                  />
                </Card>
              </Col>

              {/* ستون چپ: پیش‌نمایش */}
              <Col xs={24} lg={12}>
                <Card 
                  className="h-full"
                  title={
                    <span style={{ fontFamily: 'CustomFont' }}>پیش‌نمایش</span>
                  }
                >
                  <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg">
                    <Text 
                      style={{ 
                        fontFamily: 'CustomFont', 
                        display: 'block', 
                        marginBottom: '24px',
                        color: '#666'
                      }}
                    >
                      در صورتی که نیازمند مشاوره هستید فرم زیر را پر کنید. در کوتاه‌ترین زمان مشاورین مجموعه با شما تماس می‌گیرند.
                    </Text>
                    
                    <Form layout="vertical" className="bg-white dark:bg-gray-800 p-4 rounded-lg">
                      {enabledFields.map((field) => (
                        <Form.Item
                          key={field.id}
                          label={
                            <span style={{ fontFamily: 'CustomFont' }}>
                              {field.label}
                              {field.required && null}
                            </span>
                          }
                          required={field.required}
                        >
                          {field.key === 'message' ? (
                            <TextArea
                              rows={4}
                              placeholder={`${field.label} را وارد کنید`}
                              style={{ fontFamily: 'CustomFont' }}
                            />
                          ) : (
                            <Input
                              placeholder={`${field.label} را وارد کنید`}
                              style={{ fontFamily: 'CustomFont' }}
                            />
                          )}
                        </Form.Item>
                      ))}
                      
                      <Form.Item className="mb-0">
                        <Button
                          type="primary"
                          icon={<CheckOutlined />}
                          block
                          className="bg-blue-600 hover:bg-blue-700 border-0"
                          style={{ fontFamily: 'CustomFont' }}
                        >
                          ارسال
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </Card>
              </Col>
            </Row>

            {/* بخش Embed */}
            {/* <Divider /> */}
            {/* <Card 
              title={
                <span style={{ fontFamily: 'CustomFont' }}>کد جاسازی و لینک مستقیم</span>
              }
              className="mt-6"
            >
              <Text 
                style={{ 
                  fontFamily: 'CustomFont', 
                  display: 'block', 
                  marginBottom: '16px',
                  color: '#666'
                }}
              >
                کد را کپی کرده و در هر جایی از سایت خود قرار دهید تا فرم نمایش داده شود. همچنین می‌توانید عرض و ارتفاع px را متناسب با سایت خود تنظیم کنید.
              </Text>
              
              <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded-lg mb-4">
                <code style={{ fontFamily: 'monospace', fontSize: '14px' }}>
                  {`<iframe src="https://example.com/lead-form" width="100%" height="600px" frameborder="0"></iframe>`}
                </code>
              </div>

              <div className="mt-4">
                <Title level={5} style={{ fontFamily: 'CustomFont', marginBottom: '12px' }}>
                  لینک مستقیم:
                </Title>
                <div className="space-y-2">
                  <div className="bg-gray-100 dark:bg-gray-800 p-3 rounded-lg">
                    <code style={{ fontFamily: 'monospace', fontSize: '14px' }}>
                      https://example.com/lead-form
                    </code>
                  </div>
                  <div className="bg-gray-100 dark:bg-gray-800 p-3 rounded-lg">
                    <code style={{ fontFamily: 'monospace', fontSize: '14px' }}>
                      https://example.com/lead-form?with_logo=1
                    </code>
                  </div>
                </div>
              </div>
            </Card> */}
          </div>
        </Card>
      </div>

      <style jsx global>{`
        .custom-switch-visible .ant-switch {
          opacity: 1 !important;
          visibility: visible !important;
          min-width: 44px !important;
          height: 22px !important;
        }
        .custom-switch-visible .ant-switch-inner {
          opacity: 1 !important;
          display: block !important;
        }
        .custom-switch-visible .ant-switch-handle {
          opacity: 1 !important;
          width: 18px !important;
          height: 18px !important;
        }
        .custom-switch-visible .ant-switch-checked {
          background-color: #52c41a !important;
        }
        .custom-switch-visible .ant-switch-checked .ant-switch-handle {
          left: calc(100% - 18px - 2px) !important;
        }
        .custom-switch-visible .ant-switch:not(.ant-switch-checked) {
          background-color: rgba(0, 0, 0, 0.25) !important;
        }
        .custom-switch-visible .ant-switch:not(.ant-switch-checked) .ant-switch-handle {
          left: 2px !important;
        }
      `}</style>
    </MainLayout>
  );
};

export default LeadForm;
